import { render, staticRenderFns } from "./JobCreate.vue?vue&type=template&id=2c5b9957&scoped=true"
import script from "./JobCreate.vue?vue&type=script&lang=js"
export * from "./JobCreate.vue?vue&type=script&lang=js"
import style0 from "./JobCreate.vue?vue&type=style&index=0&id=2c5b9957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b9957",
  null
  
)

export default component.exports